/** Home quick action tiles, in their default order. */
export const DEFAULT_QUICK_ACTION_ORDER: string[] = [
  'add',
  'create',
  'scanner',
  'calculator',
  'notes',
  'serviceDisplay',
  'aiAssistant',
];

/** The default before Quick Notes moved ahead of Live Orders. */
const LEGACY_DEFAULT_QUICK_ACTION_ORDER: string[] = [
  'add',
  'create',
  'scanner',
  'calculator',
  'serviceDisplay',
  'notes',
  'aiAssistant',
];

/** Saved orders still on the legacy default get the current default;
 * orders the user rearranged are kept as they are. */
export const migrateNotesBeforeLiveOrders = (order: string[]): string[] => {
  const isLegacyDefault =
    order.length === LEGACY_DEFAULT_QUICK_ACTION_ORDER.length &&
    order.every((key, i) => key === LEGACY_DEFAULT_QUICK_ACTION_ORDER[i]);
  return isLegacyDefault ? [...DEFAULT_QUICK_ACTION_ORDER] : order;
};
